import React from 'react';
import { Container, Flex } from '../../../view/Containers';
import { HighlightedPLight } from '../../../view/Paragraph';
import { VerticalCard } from '../../../view/VerticalCard';
import team1 from './img/team_1.png';
import team2 from './img/team_2.png';
import team3 from './img/team_3.png';
import team4 from './img/team_4.png';

export const TeamSectionBody = (): JSX.Element => (
  <>
    <Container padding inColor>
      <article>
        <HighlightedPLight as="h2">
          Owocowo to przede wszystkim ludzie - nietuzinkowe postacie,
          które kochają naturę i ogrodnictwo. Gospodarstwo jest dla nas nie tylko pracą,
          ale przede wszystkim pasją. Poznajcie naszą ekipę:
        </HighlightedPLight>
      </article>
    </Container>
    <Container padding inColor>
      <Flex responsive>
        <VerticalCard image={team1} header="Paulina" upperSubHeader="szefowa">
          Paulina ogarnia całość przedsięwzięcia w najmniejszym detalu.
          Dba o przepisy i receptury, dogląda księgowość, wspomaga lokalny punkt,
          ale przede wszystkim dba o gospodarstwo i zbiory owoców i warzyw.
          <br />
          <br />
          <b>tel: 506 165 383</b>
          <br />
          <b>paulina@owocowo.com.pl</b>
        </VerticalCard>
        <VerticalCard image={team2} header="Łukasz" upperSubHeader="szef">
          Mąż Pauliny, który dba zarówno o gospodarstwo jak i sprzedaż produktów.
          To Łukasz wyszukuje nowe rośliny, wymyśla nowe plantacje,
          a nowe linie produktów to głównie jego pomysły.
          Jest też naszą encyklopedią wiedzy na temat zdrowtnych właściwości roślin.
          <br />
          <br />
          <b>lukasz@owocowo.com.pl</b>
        </VerticalCard>
      </Flex>
    </Container>
  </>
);
